
require("ex-chord-js");
require("style.css");


//////////////////
// WEBPACK FOOTER
// ./src/main/web/main.js
// module id = 4
// module chunks = 0